module.exports = __webpack_public_path__ + "static/img/12.a5fd708.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/12.png
// module id = qPkQ
// module chunks = 0